import { create } from 'zustand';

import { getScanQueue } from '../services/api/abhaApi';

let inFlight = null;
let epoch = 0; // bumped by reset(): a response from before a sign-out must not refill the store

/**
 * Scan & Share waiting list (R56) - ONE shared copy for the dashboard card count and the list.
 * `load` is single-flight (concurrent callers share the promise); polling lives in ONE place,
 * ScanShareQueueSync, so the card and the list can never double-fetch.
 */
const useScanQueueStore = create((set) => ({
  entries: null,        // null = not loaded yet
  updatedAt: null,      // ms epoch of the last successful load
  loadError: false,

  load: () => {
    if (inFlight) return inFlight;
    const mine = epoch;
    const p = getScanQueue()
      .then((res) => { if (mine === epoch) set({ entries: res.entries, updatedAt: Date.now(), loadError: false }); })
      .catch(() => { if (mine === epoch) set({ loadError: true }); })
      .finally(() => { if (mine === epoch) inFlight = null; });
    inFlight = p;
    return p;
  },

  /** Sign-out: clear org data and orphan any request still in flight. */
  reset: () => {
    epoch += 1;
    inFlight = null;
    set({ entries: null, updatedAt: null, loadError: false });
  },
}));

export default useScanQueueStore;
